// extracted by mini-css-extract-plugin
export default {"topFlex":"styles_topFlex__V2Kvb","topTitle":"styles_topTitle__qddLV","topTitleLeft":"styles_topTitleLeft__Qo63B"};